import { c as _c } from "react/compiler-runtime";
import { Card, CardContent, CardHeader, CardTitle } from './Card';
import { FlexContainer } from './FlexContainer';
import { Separator } from './Separator';
import { Skeleton } from './Skeleton';
export function SheetSkeleton() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CardTitle><Skeleton height={20} width={80} /></CardTitle>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CardHeader><FlexContainer items="center" justify="between">{t0}<FlexContainer className="gap-2" items="center"><Skeleton borderRadius={12} height={22} width={70} /><Skeleton borderRadius={12} height={22} width={60} /></FlexContainer></FlexContainer></CardHeader>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Separator className="mb-4" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Card>{t1}<CardContent>{t2}<FlexContainer className="gap-3" direction="column">{Array.from({
            length: 5
          }).map(_temp)}</FlexContainer></CardContent></Card>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CardHeader><CardTitle><Skeleton height={20} width={60} /></CardTitle></CardHeader>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Separator className="mb-4" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FlexContainer className="gap-6" direction="column" items="stretch">{t3}<Card>{t4}<CardContent>{t5}<FlexContainer className="gap-3" direction="column">{Array.from({
              length: 3
            }).map(_temp2)}</FlexContainer></CardContent></Card></FlexContainer>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}
function _temp2(__0, i_0) {
  return <FlexContainer items="center" justify="between" key={i_0}><Skeleton height={14} width={80} /><Skeleton height={14} width={160} /></FlexContainer>;
}
function _temp(_, i) {
  return <FlexContainer items="center" justify="between" key={i}><Skeleton height={14} width={100} /><Skeleton height={14} width={180} /></FlexContainer>;
}